import React from 'react'
import { TrendingUp, TrendingDown } from 'lucide-react'
import { cn } from '../../lib/utils'

const colorMap = {
  indigo: 'bg-indigo-500',
  purple: 'bg-purple-500',
  emerald: 'bg-emerald-500',
  amber: 'bg-amber-500',
  blue: 'bg-blue-500',
  cyan: 'bg-cyan-500',
  orange: 'bg-orange-500',
  rose: 'bg-rose-500',
  pink: 'bg-pink-500',
  teal: 'bg-teal-500',
  red: 'bg-red-500',
  gray: 'bg-gray-500',
}

export default function StatCard({ title, value, change, icon: Icon, suffix = '', color = 'indigo', subtitle, onClick }) {
  const Wrapper = onClick ? 'button' : 'div'
  return (
    <Wrapper
      onClick={onClick}
      className={cn(
        "bg-white rounded-xl p-5 shadow-sm border border-gray-200 hover:shadow-md transition-shadow text-left",
        onClick && "cursor-pointer"
      )}
    >
      <div className="flex items-center justify-between mb-3">
        {Icon && (
          <div className={cn("w-10 h-10 rounded-xl flex items-center justify-center", colorMap[color] || 'bg-indigo-500')}>
            <Icon className="w-5 h-5 text-white" />
          </div>
        )}
        {change !== undefined && change !== null && change !== 0 && (
          <div className={cn("flex items-center text-sm font-medium", change > 0 ? 'text-emerald-600' : 'text-rose-500')}>
            {change > 0 ? <TrendingUp className="w-4 h-4 mr-1" /> : <TrendingDown className="w-4 h-4 mr-1" />}
            {Math.abs(change)}%
          </div>
        )}
      </div>
      <p className="text-2xl font-bold text-gray-900">
        {typeof value === 'number' ? value.toLocaleString() : value}{suffix}
      </p>
      <p className="text-sm text-gray-500 mt-1">{title}</p>
      {subtitle && <p className="text-xs text-gray-400 mt-0.5">{subtitle}</p>}
    </Wrapper>
  )
}
